/* @flow */

import * as React from 'react';
import SelectField from 'app/components/form/SelectField';
import t from 'app/utils/translate';

type Props = {
  options: Array<*>,
  defaultText?: string,
  disabled?: boolean,
  label?: string,
  lightContent?: boolean,
  onChange: string => void,
  value?: string,
};

class StateSelect extends React.Component<Props> {
  props: Props;

  static defaultProps = {
    defaultText: undefined,
    disabled: false,
    value: undefined,
    label: t('Country'),
    lightContent: false,
  };

  render() {
    const { options, defaultText, disabled, label, lightContent, onChange, value } = this.props;
    const states = options;

    if (!options.find(opt => opt.value === value)) {
      states.unshift({
        id: 0,
        label: value,
        value,
      });
    }

    return (
      <SelectField
        defaultText={defaultText}
        disabled={disabled}
        label={label}
        lightContent={lightContent}
        name="state"
        options={states}
        onChange={onChange}
        value={value}
      />
    );
  }
}

export default StateSelect;
